export const checkIsMessageRead = (
  lastReadConversationTs: number,
  messageTs: number
) => lastReadConversationTs > messageTs;
